export const PrimaryColor = '#2980b9'
export const SecondaryColor = '#f39c12'
